
function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("bjsPb", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $4a64cd4b268e66df$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Spanish (International)
var $4a64cd4b268e66df$export$2e2bcd8739ae039 = {
    'extension.charts.aggregateData': 'Agregar datos',
    'extension.charts.aggregateDataDescription': 'Combina los valores en un solo punto de datos cuando varias filas presentan el mismo valor.',
    'extension.charts.category': "Categor\xeda",
    'extension.charts.customizeTab': 'Personalizar',
    'extension.charts.dataMissing.details': "No podemos encontrar la tabla de origen de este gr\xe1fico en la p\xe1gina.",
    'extension.charts.dataMissing.title': 'No hay datos que mostrar',
    'extension.charts.dataTab': 'Datos',
    'extension.charts.defaultColumnName': 'Columna {0}',
    'extension.charts.defaultTitle': "Gr\xe1fico sin t\xedtulo",
    'extension.charts.defaultYLabel': "Eje sin t\xedtulo",
    'extension.charts.extensionTitle': "Gr\xe1fico",
    'extension.charts.height': "Altura del \xe1rea del gr\xe1fico",
    'extension.charts.height.large': "M\xe1s alta",
    'extension.charts.height.medium': 'Predeterminado',
    'extension.charts.height.small': "M\xe1s corta",
    'extension.charts.horizontal.orientation.label': 'Horizontal',
    'extension.charts.insert.tooltip': "Insertar gr\xe1fico",
    'extension.charts.legend': 'Leyenda',
    'extension.charts.legend.auto': "Autom\xe1tico",
    'extension.charts.legend.bottom': 'Debajo',
    'extension.charts.legend.left': 'Izquierda',
    'extension.charts.legend.position': "Posici\xf3n de la leyenda",
    'extension.charts.legend.right': 'Derecha',
    'extension.charts.legend.show': 'Mostrar leyenda',
    'extension.charts.legend.top': 'Arriba',
    'extension.charts.options.label': "Opciones de gr\xe1fico",
    'extension.charts.options.tooltip': "Cambiar las opciones del gr\xe1fico",
    'extension.charts.orientation.label': "Orientaci\xf3n",
    'extension.charts.seriesNames': 'Series de datos',
    'extension.charts.showPoints': 'Mostrar puntos de datos',
    'extension.charts.smoothLines': "L\xedneas suaves",
    'extension.charts.style': 'Estilo',
    'extension.charts.title': "T\xedtulo",
    'extension.charts.type.bar': 'Barras',
    'extension.charts.type.fieldDescription': "Tipo de gr\xe1fico",
    'extension.charts.type.line': "L\xedneas",
    'extension.charts.type.pie': 'Circular',
    'extension.charts.userTitle': "T\xedtulo",
    'extension.charts.vertical.orientation.label': 'Vertical',
    'extension.charts.xAxis': 'Eje X',
    'extension.charts.xLabel': 'Etiqueta del eje X',
    'extension.charts.yLabel': 'Etiqueta del eje Y'
};

});


//# sourceMappingURL=es.25549d98.js.map
